export const formatHardwareLabel = (hardware) => {
  if (!hardware?.name) return '';
  const version = hardware.version_tag?.trim();
  return version ? `${hardware.name} (${version})` : hardware.name;
};
